import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './lib/auth';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import PartyPage from './pages/PartyPage';
import DashboardPage from './pages/DashboardPage';
import AdminPage from './pages/AdminPage';
import AuthCallback from './pages/AuthCallback';
import SEOLandingPage from './pages/SEOLandingPage';
import GalleryPage from './pages/GalleryPage';
import ReviewsPage from './pages/ReviewsPage';
import UpcomingPage from './pages/UpcomingPage';
import './index.css';

function AppRouter() {
    const location = useLocation();

    // Scroll to top on every route change so in-page links always land at the top.
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, [location.pathname]);

    if (location.hash?.includes('session_id=')) return <AuthCallback />;
    return (
        <Layout>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/upcoming" element={<UpcomingPage />} />
                <Route path="/reviews" element={<ReviewsPage />} />
                <Route path="/party" element={<PartyPage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/gallery" element={<GalleryPage />} />
                <Route path="/best-caribbean-cruises" element={<SEOLandingPage />} />
                <Route path="/best-party-cruises" element={<SEOLandingPage />} />
                <Route path="/family-cruise-vacations" element={<SEOLandingPage />} />
                <Route path="/luxury-cruise-packages" element={<SEOLandingPage />} />
                <Route path="/cruise-deals" element={<SEOLandingPage />} />
                <Route path="/cruise-excursions" element={<SEOLandingPage />} />
                <Route path="/cruise-travel-agent-near-me" element={<SEOLandingPage />} />
                <Route path="/all-inclusive-cruise-packages" element={<SEOLandingPage />} />
            </Routes>
        </Layout>
    );
}

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <AppRouter />
                <Toaster theme="dark" position="top-right" />
            </BrowserRouter>
        </AuthProvider>
    );
}
